import { Box } from "@mui/material";
import React from "react";

const colorMap = {
  success: "#2e7d32",
  error: "#d32f2f",
  warning: "#FFC107",
  info: "#00B8D4",
};

const CustomChip = ({
  value,
  label,
  color,
}: {
  value: string;
  label?: string;
  color?: keyof typeof colorMap;
}) => {
  return (
    <Box
      sx={{
        border: "1px solid #e0e0e0",
        borderRadius: "4px",
        padding: "4px",
        fontSize: "0.7rem",
        px: 0.5,
        py: 0,
        display: "flex",
        alignItems: "center",
        gap: 1,
        ...(color && {
          backgroundColor: colorMap[color],
          color: "#fff",
        }),
      }}
    >
      {label ? `${label} : ${value}` : value}
    </Box>
  );
};

export default CustomChip;
